function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_95",
  "data-name": "Group 95",
  transform: "translate(-1094 -1712)"
}, React.createElement("g", {
  className: "circle",
  id: "Ellipse_1",
  "data-name": "Ellipse 1",
  transform: "translate(1094 1712)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 3
}, React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  stroke: "none"
}), React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 18.5,
  fill: "none"
})), React.createElement("g", {
  className: "x",
  id: "Group_94",
  "data-name": "Group 94",
  transform: "translate(1075 1604)"
}, React.createElement("path", {
  className: "x",
  id: "Union_4",
  "data-name": "Union 4",
  d: "M-851-943l-8.157,8Zm-16,0,7.843,8Z",
  transform: "translate(-901 987) rotate(90)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4
})));

var SvgBackIconCircled = function SvgBackIconCircled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBackIconCircled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/back-icon_circled.5e5a3966.svg";
export { ForwardRef as ReactComponent };